const ComponentDetails = {
  'id': 'ComponentDetails',
  'layout': {
    'rows': 1,
    'columns': 2
  },
  'fields': [
    {
      'id': 1,
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 1.5,
      },
      'type': 'PAPER_CONTAINER',
      'visible': true,
      'props': {
        'fullWidth': true
      },
      'children': [
        {
          'id': 0,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'label': 'Product description ',
            'name': 'ProductDescription',
            'size': 'large',
            'required': false,
            'readOnly': true,
          }
        },
        {
          'id': 1,
          'type': 'EXTENDED_TEXT_FIELD',
          'visible': true,
          'props': {
            'label': 'Ordered',
            'name': 'OrderedQuantity',
            'size': 'medium',
            'required': false,
            'readOnly': true,
            'alignment': 'right',
          }
        },
        {
          'id': 2,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'name': 'PickingQuantityDisplay',
            'label': 'Picking',
            'size': 'medium',
            'required': false,
            'readOnly': true,
            'alignment': 'right',
          }
        },
        {
          'id': 3,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'name': 'UsageQuantityDisplay',
            'label': 'Usage',
            'size': 'medium',
            'alignment': 'right',
            'required': false,
            'readOnly': true
          }
        },
        {
          'id': 4,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'name': 'BackorderQuantityDisplay',
            'label': 'On Backorder',
            'size': 'medium',
            'required': false,
            'readOnly': true,
            'alignment': 'right',
          }
        }
      ]
    },
    {
      'id': 1,
      'position': {
        'row': 1,
        'col': 2,
        'colspan': 1.5,
      },
      'type': 'PAPER_CONTAINER',
      'visible': true,
      'props': {
        'fullWidth': true
      },
      'children': [
        {
          'id': 0,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'label': 'Reserved',
            'name': 'ReservedQuantityDisplay',
            'size': 'medium',
            'alignment': 'right',
            'required': false,
            'readOnly': true,
          }
        },
        {
          'id': 1,
          'type': 'TEXT_FIELD',
          'visible': true,
          'props': {
            'label': 'Committed',
            'name': 'CommittedQuantityDisplay',
            'size': 'medium',
            'type': 'number',
            'decimalSeparator': true,
            'required': false,
            'readOnly': true,
          }
        },
        {
          'id': 1,
          'type': 'TEXT_AREA',
          'props': {
            'name': 'ComponentLineComment',
            'label': 'Component line comment',
            'fullWidth': true,
            'style': {
              'height': '200px'
            }
          }
        }
      ]
    }
  ]
}
export default ComponentDetails;
